import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OeAppService } from '../oe-app.service';
import { Store } from '../store';
import { TranslationService } from '../translation.service';
import { TranslatorLanguage } from '../types/translator-language';
import { TranslateResult } from './TranslateResult';

@Injectable()
export class TranslatorToolService extends Store<Array<TranslatorLanguage>> {
  constructor(private http: HttpClient, translationService: TranslationService, private oeAppService: OeAppService) {
    super([]);
    translationService.supportedLanguages$.subscribe((languages) =>
      this.setState(languages.map((lang) => ({ isoCode: lang.code, name: lang.language })))
    );
  }

  translate(payload: { text: string; sourceLanguage?: string; targetLanguage?: string }) {
    return this.http.post<TranslateResult>(`${this.oeAppService.thirdPartyServiceHost}/v1/tools/translate`, payload);
  }

  getTranslatorLanguages(): Array<TranslatorLanguage> {
    return this.state;
  }

  isLanguageSupported(isoCode: string) {
    let isSupported = false;
    this.state.forEach((lang) => {
      if (lang.isoCode === isoCode) {
        isSupported = true;
        return;
      }
    });
    return isSupported;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/translator-tool/translator-tool.service.ts